import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const ADD_ORDHEADS = 'ADD_ORDHEADS'
const ADD_ORDHEAD_TO_STACK = 'ADD_ORDHEAD_TO_STACK'
const DELETE_ORDHEAD_FROM_STACK = 'DELETE_ORDHEAD_FROM_STACK'
const EDIT_ORDHEAD_IN_STACK = 'EDIT_ORDHEAD_IN_STACK'
const LOGOUT_USER = 'LOGOUT_USER'

//console.log('createOrderhead: '+ ADD_ORDHEADS)

const orderhead_obj = {
    namespaced: true,
    state: {
        orderhead: []
    },
    mutations: {
        ADD_ORDHEADS (state, data) {
            state.orderhead = state.orderhead.concat(data)
        },
        ADD_ORDHEAD_TO_STACK (state, orderhead_obj) {
            state.orderhead.unshift(orderhead_obj)
        },
        DELETE_ORDHEAD_FROM_STACK (state, orderhead_obj) {
            if (state.orderhead.length) {
                let i = state.orderhead.map(orderhead_obj => orderhead_obj.id).indexOf(orderhead_obj.id)
                state.orderhead.splice(i, 1)
            }
        },
        EDIT_ORDHEAD_IN_STACK (state, orderhead_obj) {
            if (state.orderhead.length) {
                let i = state.orderhead.map(orderhead_obj => orderhead_obj.id).indexOf(orderhead_obj.id)
                Vue.set(state.orderhead, i, orderhead_obj)
            }
        },
        LOGOUT_USER (state) {
            state.orderhead = []
        }
    },
    getters: {
        orderhead (state) {
            return state.orderhead
        }
    },
    actions: {
        // API Calls
        async getUsersOrderhead ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('orderhead', {params: {order: data.order, page: data.page, type: data.type, limit: data.limit}})
                commit(ADD_ORDHEADS, response.data)
                //console.log('getUsersOrderhead: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getAFUsersOrderhead ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('orderheadAF', {params: {af_user_id: data.af_user_id, order: data.order, page: data.page, type: data.type}})
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getTotalNumberLimit ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                //const response = await axios.get('orderhead/totalLimit', {params: {lottotype_id: data.lottotype_id, round_id: data.round_id, bettype_id: data.bettype_id, number: data.number, }})
                const response = await axios.get('orderheadTotalLimit', {params: {lottotype_id: data.lottotype_id, round_id: data.round_id, bettype_id: data.bettype_id, number: data.number, }})
                //commit(ADD_ORDHEADS, response.data)
                //console.log('getTotalNumberLimit: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getOrderhead ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('orderhead/' + data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async createOrderhead ({ dispatch, commit, getters, rootGetters }, data) {
            //console.log('createOrderhead data: ', data)
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                return await axios.post('orderhead', {oh_total: data.oh_total, status_id: data.status_id, currency_id: data.currency_id, lottotype_id: data.lottotype_id, round: data.round, itemdata: data.itemdata, round_date: data.round_date, round_id: data.round_id })
            } catch (error) {
                //throw new Error(error)
                throw error
            }
        },

        async cancelOrder ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('data', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                return await axios.put('orderhead/cancelorder/' + data.id, data)
            } catch (error) {
                throw new Error(error)
            }
        },

        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
        async addOrderheadToStack ({ dispatch, commit, getters, rootGetters }, orderhead_obj) {
            try {
                commit(ADD_ORDHEAD_TO_STACK, orderhead_obj)
            } catch (error) {
                throw new Error(error)
            }
        },
        async deleteOrderheadFromStack ({ dispatch, commit, getters, rootGetters }, orderhead_obj) {
            try {
                commit(DELETE_ORDHEAD_FROM_STACK, orderhead_obj)
            } catch (error) {
                throw new Error(error)
            }
        },
        async editOrderheadInStack ({ dispatch, commit, getters, rootGetters }, orderhead_obj) {
            try {
                commit(EDIT_ORDHEAD_IN_STACK, orderhead_obj)
            } catch (error) {
                throw new Error(error)
            }
        }
    }
}

export default orderhead_obj
